export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/11a14d9b63ec892bb84cea8c67204259.svg";